module.exports = __webpack_public_path__ + "media/images/h_tel-0b5c9808.png";